module.exports = __webpack_public_path__ + "static/media/favicon.8d4f535e.ico";